<template>
    <div class="famous-pedia-edit-web-page dsp-flex">
        <!-- 1. 顶部操作栏 -->
        <web-famous-pedia-top-bar></web-famous-pedia-top-bar>
        
        <!-- 2. 左边部分 -->
        <famous-pedia-left-web></famous-pedia-left-web>

        <div class="famous-pedia-edit-web-right">
            <!-- 1. 顶部菜单栏 -->
            <famous-title-bar
                v-bind:fromPage="pageName"
                v-bind:titleName="curPediaBaziInfo.f_name">
            </famous-title-bar>
            <!-- 3. 迷你命盘部分 -->
            <div class="famous-form-ew-fatefortune">
                <mini-fate-fortune-panel
                    v-if="showPediaCommentFateFortune"
                    v-bind:fromPage="pageName"
                    v-bind:fortuneItemFunc="changeFateSideListData"
                    v-bind:fateSideCloseFunc="changeFateSideListData">
                </mini-fate-fortune-panel>
            </div>
            <!-- 主要内容部分 -->
            <famous-form-web></famous-form-web>            
        </div>
    </div>
</template>

<script>
import WebFamousPediaTopBar from '../../layouts/web/WebFamousPediaTopBar.vue'
import MiniFateFortunePanel from '../../layouts/panel/MiniFateFortunePanel.vue'
import CommentContentRead from '../../layouts/comment/CommentContentRead.vue'
import FamousTitleBar from '../../layouts/famouspedia/FamousTitleBar.vue'
import FamousFormWeb from '../../layouts/famouspediaweb/FamousFormWeb.vue'
import FamousPediaLeftWeb from '../../layouts/famouspediaweb/FamousPediaLeftWeb.vue'
import { DOM, FAMOUS_DOM } from '../../modules/dom';
export default {
    name: 'FamousPediaEditWeb',
    components: { WebFamousPediaTopBar, MiniFateFortunePanel, CommentContentRead, FamousTitleBar, FamousFormWeb, FamousPediaLeftWeb },
    computed: {
        gotCurrentPediaData() {
            return this.$store.state.famouspedia.gotCurrentPediaData
        },
        curPediaBaziInfo() {
            return this.$store.state.famouspedia.curPediaBaziInfo;
        },
        curPediaPipanInfo() {
            return this.$store.state.famouspedia.curPediaPipanInfo;
        },
        curPediaBaziEditInfo() {
            return this.$store.state.famouspedia.curPediaBaziEditInfo
        },
        showPediaCommentFateFortune() {
            return this.$store.state.famouspediacomment.showPediaCommentFateFortune
        }
    },
    data() {
        return {
            pageName: 'FamousPediaEditWeb',
        }
    },
    created() {
        if(!this.gotCurrentPediaData) {
            this.$router.replace('/famouspediacreate');
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initDom();
        }, 20);
    },
    methods: {
        initDom() {
            this.$el.style.minHeight = (innerHeight - 40) + 'px';
        },
        clickEditHistory() {
            this.$store.dispatch('famouspedia/getBaikeLog');
            // 打开编辑历史弹框
            this.$store.state.weblogin.showWebFamousPediaPop = true;
            var me = this;
            setTimeout(() => {
                me.$store.state.weblogin.showWebFamousPediaPop = false;
            }, 5000);
            this.$store.state.weblogin.curWebFamousPediaMenu = 4;
        },
        // 迷你命盘运盘的数据与大运流年数据的联动
        changeFateSideListData(data, fateSideListData) {
            // FAMOUS_DOM.bindFamousFormScrollEvent(false);
            var commentAllKey = this.$store.state.famouspediacomment.commentAllKey,
                commentAllYear = this.$store.state.famouspediacomment.commentAllYear,
                curPediaDayunLiunianList = this.$store.state.famouspedia.curPediaDayunLiunianList,
                showPediaCommentAllList = this.$store.state.famouspediacomment.showPediaCommentAllList,
                commentTotalReplyData = this.$store.state.famouspediacomment.commentTotalReplyData;
            if(fateSideListData.length == 0) {
                this.updateDom('');
            }else {
                if(data.type == 'dayun') {
                    this.updateDom(data.type + data.year)
                    // 更新流年的评论状态
                    this.$store.dispatch('minifatefortune/updateFamousMiniLiunianListCommentStatus', {
                        pediaList: curPediaDayunLiunianList,
                        commentData: commentTotalReplyData
                    });
                }else if(data.type == 'liunian') {
                    this.updateDom(data.type + data.year)
                    // 更新当前全部评论列表的数据
                    if(fateSideListData.length == 2) {
                        var dayunIndex = fateSideListData[0].index,
                            liunianIndex = fateSideListData[1].index, liunianYear = fateSideListData[1].year,
                            dayunData = curPediaDayunLiunianList[dayunIndex],
                            liunianData = dayunData['liunian'][liunianIndex],
                            curKey = 'big_' + dayunData.key + '_' + liunianData.key;
                        if(liunianData.content != '' && showPediaCommentAllList) {
                            this.updateCommentAllList(curKey);
                        }
                    }
                }
            }
            // setTimeout(() => {
            //     FAMOUS_DOM.bindFamousFormScrollEvent(true);
            // }, 1000);
        },
        updateCommentAllList(key) {
            var me = this,
                curId = this.$store.state.famouspedia.curPediaBaziId;
            this.$store.dispatch('famouspediacomment/setCommentFormData', {
                formData: {
                    bid: curId,
                    f_type: key,
                    parentsid: 0,
                    touid: 0
                }
            })
            this.$store.dispatch('famouspediacomment/initCommentAllListData', { 
                key: key,
                cb: function() {
                    setTimeout(() => {
                        // FAMOUS_DOM.updateFamousFormStyle();
                        // FAMOUS_DOM.bindFamousFormScrollEvent(false);
                        window.scrollTo(0, 0);
                    }, 20);
                }
            });
        },
        updateDom(curName) {
            setTimeout(() => {
                FAMOUS_DOM.updateFamousEditFormScrollTop(curName);
            }, 100);
        },
    }
}
</script>